//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DialogForm',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    rolesConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isRequest: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      dialogFormVisible: false,
      tableFrom: {
        type: '',
        id: ''
      },
      option: {
        form: {
          labelWidth: '75px'
        },
        submitBtn: false,
        global: {
          frame: {
            props: {
              closeBtn: false,
              okBtn: false,
              onLoad: function onLoad(e) {
                e.fApi = _this.$refs.fc.$f;
              }
            }
          }
        }
      },
      // 表单配置
      rules: []
    };
  },
  watch: {
    rolesConfig: {
      handler: function handler(nVal, oVal) {
        this.rules = this.rolesConfig;
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogFormVisible = false;
    },
    open: function open() {
      this.dialogFormVisible = true;
    },
    // 提交
    handleConfirm: function handleConfirm() {
      this.tableFrom.type = 1;
      this.tableFrom.id = this.rolesConfig.entId;
      this.$emit('isEnterprise', this.tableFrom);
      this.handleClose();
    },
    handleTab: function handleTab() {
      this.tableFrom.type = 2;
      this.tableFrom.id = this.rolesConfig.entId;
      this.$emit('isEnterprise', this.tableFrom);
      this.handleClose();
    }
  }
};